<template>
  <div>
    <div class="col-xs-12 col-sm-3" style="padding: 15px;">
      <div class="photo"
           ref="photo"
           @click="onClick"
           @mouseenter="onMouseEnter"
           @mouseleave="onMouseLeave">
        <!-- <transition name="zoom"> -->
          <div class="photo-overlay" v-if="active">
            <div class="photo-overlay-inner">
              <h4>{{ photo.title }}</h4>
              <ul class="list-unstyled">
                <li>
                  <a v-if="photo.url"
                     :href="photo.url"
                     target="_blank">SN&amp;R article</a>
                </li>
                <li>
                  <a v-if="photo.issuu && photo.issuu.url"
                     :href="photo.issuu.url"
                     target="_blank">Flipbook</a>
                </li>
              </ul>
            </div>
          </div>
        <!-- </transition> -->
        <img :src="photo.cover">
      </div>
    </div>

    <div v-if="(index + 1) % 4 === 0"
         class="clearfix visible-sm-block"></div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      inHover: false
    }
  },
  props: {
    photo: {
      type: Object,
      default: null
    },
    active: {
      type: Boolean,
      default: false
    },
    index: {
      type: Number,
      default: null
    }
  },
  methods: {
    menuToggle (state) {
      this.$emit('newActive', {photoId: this.photo.id, status: state})
    },
    onClick () {
      if (this.inHover) {
        return
      }
      this.menuToggle(!this.active)
    },
    onMouseEnter () {
      this.inHover = true
      this.menuToggle(true)
    },
    onMouseLeave () {
      this.inHover = false
      this.menuToggle(false)
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '@/assets/scss/_site_variables.scss';
  @import '@/assets/scss/partials/_mixins.scss';

  .zoom-enter-active {
    animation: animatezoom  .2s ease-in forwards;
  }

  @keyframes animatezoom {
      from {transform: scale(1.05)}
      to {transform: scale(1)}
  }

  .fade-enter {
    opacity: 0;
  }

  .fade-enter-active {
    transition: opacity 1s;
  }

  .fade-leave {
    /*opacity: 1;*/
  }

  .fade-leave-active {
    transition: opacity .4s;
    opacity: 0;
  }

  .photo {
    position: relative;
    margin-bottom: 15px;

    img {
      /* Just in case there are inline attributes */
      width: 100% !important;
      height: auto !important;
    }
  }

  .photo-overlay {
    margin: auto;
    position: absolute;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
    background: rgba(0, 0, 0, .8);
    text-align: center;
    font-size: 2vw;
    border: 1px solid #000000;
    box-shadow: inset 0 0 10px #000;
  }

  .photo-overlay-inner {
    position: relative;
    top: 20%;
    // transform: translateY(50%);

    h4 {
      font-size: 1.2em;
      font-weight: 700;
      text-shadow: 1px 1px 2px #000000;
      margin-top: 0px;
    }

    a {
      font-weight: 700;
      text-shadow: 0 0 1px #000;
      font-style: italic;
      padding: 2px 5px;

      &:hover {
        color: $brand-primary;
      }
    }

    li {
      padding: 0;
      margin: 0;
      line-height: 30px;
    }
  }

  @media screen and (max-width: 770px) {
    #photos {
      @include columns(2, 15px);

      .photo-overlay {
        padding: 20px;
        font-size: 6.5vw;

        li {
          line-height: 35px;
        }
      }
    }
  }

  @media screen and (max-width: 500px) {
    #photos {
      @include columns(1, 15px);

      .photo-overlay {
        li {
          line-height: 25px;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Photo.vue